import React, { FC } from 'react';
import { useTheme } from 'styled-components';

const RADIAN = Math.PI / 180;

interface IPieLabel {
  cx: number;
  cy: number;
  innerRadius: number;
  midAngle: number;
  name: 'Weak' | 'Normal' | 'Strong';
  outerRadius: number;
}

const PieLabel: FC<IPieLabel> = ({ cx, cy, innerRadius, midAngle, name, outerRadius }) => {
  const theme = useTheme();

  const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + 2.5 + radius * Math.sin(-midAngle * RADIAN);

  const rotationAngle = midAngle - 90;

  return (
    <text
      textAnchor="middle"
      dominantBaseline="middle"
      fill={theme.colors.neutral.primary[0]}
      fontSize="14"
      fontWeight="700"
      style={{ transform: `rotate(${-rotationAngle}deg)`, transformOrigin: `${x}px ${y}px` }}
      {...{ x, y }}
    >
      {name}
    </text>
  );
};

export default PieLabel;
